// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root___qkxz","rotation":"Tooltip_rotation__aCBny"};